import { useEffect } from "react";
import Lenis from "lenis";
import HeaderNav from "@/components/HeaderNav";
import KineticHero from "@/components/KineticHero";
import Marquee from "@/components/Marquee";
import Chapters from "@/components/Chapters";
import AppPreview from "@/components/AppPreview";
import Waitlist from "@/components/Waitlist";
import SupportSection from "@/components/SupportSection";
import FooterSection from "@/components/FooterSection";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main className="grain relative min-h-screen overflow-x-clip bg-[#08090C] text-slate-50">
      <HeaderNav />
      <KineticHero />
      <Marquee />
      <Chapters />
      <AppPreview />
      <Waitlist />
      <SupportSection />
      <FooterSection />
    </main>
  );
}
